import {SubscriptionType} from "@/lib/types/statuspages.ts";
import {StatusPageSubscribersImportActionButton} from "@/pages/statuspages/tabs/subscribers/actions/StatusPageSubscribersImportActionButton.tsx";
import {subscriptionTypeNames} from "@/pages/statuspages/tabs/subscribers/StatusPageSubscribersTable.utils.tsx";

export interface StatusPageSubscribersTableEmptyStateProps {
  variant: "general" | "filter";
  subscriptionType: SubscriptionType;
}

export const StatusPageSubscribersTableEmptyState = ({
  variant,
  subscriptionType,
}: StatusPageSubscribersTableEmptyStateProps) => {
  if (variant === "filter") {
    return <span className="p-2 py-3">No Subscribers found matching the filter(s) above.</span>;
  }
  return (
    <div className="w-100 d-flex flex-column align-items-center justify-content-center gap-3 py-4">
      <div className="pulseTextBodyBold">
        This Status Page does not have any {subscriptionTypeNames[subscriptionType]} subscribers.
      </div>
      <StatusPageSubscribersImportActionButton>Import Subscribers</StatusPageSubscribersImportActionButton>
    </div>
  );
};
